import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createCalculation, updateCalculation } from '@/features/agreements/services/calculationsService';
import { agreementsQueryKeys } from '@/features/agreements/hooks/useAgreements';

export const useCreateCalculation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ agreementId, data }) => createCalculation(agreementId, data),
    onSuccess: (_, { agreementId }) => {
      void queryClient.invalidateQueries({
        queryKey: agreementsQueryKeys.detail(agreementId),
      });
    },
  });
};

export const useUpdateCalculation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ agreementId, calculationId, data }) =>
      updateCalculation(agreementId, calculationId, data),
    onSuccess: (_, { agreementId }) => {
      void queryClient.invalidateQueries({
        queryKey: agreementsQueryKeys.detail(agreementId),
      });
    },
  });
};
